import React, { useEffect, useState } from "react";
// import styles from "./CommonEditorFile.module.css";
import { API_BASE_URL } from "configs/AppConfig";
import CommonBanner from "../common-banner/CommonBanner";
import { Spin } from "antd";
import Loader from "../Loader/Loader";
import MetaDetails from "components/meta-details/MetaDetails";
import ArrowDesign from "components/UI/icons/ArrowDesign";
import useWindowWidth from "helpers/useWindowWidth";

function CommonEditorFile({ data, title, loading }) {
  console.log("data in page", data);
  const width = useWindowWidth();
  return (
    <>
      <MetaDetails
        title={data?.metatitle}
        description={data?.metadescription}
        keywords={data?.metakeywords?.join(", ")}
      />
      {loading ? (
        <Loader />
      ) : (
        <div className="businessOuter">
          <CommonBanner title={title} image={data?.image} />
          <div>
            <div dangerouslySetInnerHTML={{ __html: data?.description }}></div>
          </div>
        </div>
      )}
    </>
  );
}

export default CommonEditorFile;
